import React from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { useTranslation } from 'react-i18next';

import { useMembership } from '../../hooks/users';

interface Props {
  featureTitle: string;
  tooltipTextForVIP?: string;
  children: React.ReactElement;
}

const FeatureRequiresVIPTooltip: React.FC<Props> = ({
  children,
  featureTitle,
  tooltipTextForVIP,
}) => {
  const hasMembership = useMembership();

  const { t } = useTranslation();

  let overlay = null;
  if (tooltipTextForVIP) {
    overlay = (
      <Tooltip style={{ pointerEvents: 'none' }} id="pay-to-unlock">
        {tooltipTextForVIP}
      </Tooltip>
    );
  }
  if (!hasMembership) {
    overlay = (
      <Tooltip style={{ pointerEvents: 'none' }} id="pay-to-unlock">
        {t('you-need-to-pay-to-unlock')}
        <strong>{featureTitle}</strong>.
      </Tooltip>
    );
  }

  return (
    <>
      {overlay ? (
        <OverlayTrigger placement="auto-start" overlay={overlay}>
          {children}
        </OverlayTrigger>
      ) : (
        children
      )}
    </>
  );
};

export default FeatureRequiresVIPTooltip;
